import React$1 from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';
import StyledTeaserOverview from './TeaserOverview.style.js';

const TeaserOverview = ({
  headline,
  subline,
  link
}) => /*#__PURE__*/React$1.createElement(StyledTeaserOverview, {
  className: "teaserOverview",
  hasLink: link
}, headline && /*#__PURE__*/React$1.createElement("div", {
  className: "teaserOverview__headline"
}, link ? /*#__PURE__*/React$1.createElement(Link$1, _extends({
  noHover: true
}, link, {
  icon: null
}), /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
  as: "h2",
  variant: "subline",
  text: headline
})) : /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
  as: "h2",
  variant: "subline",
  text: headline
}), /*#__PURE__*/React$1.createElement("div", {
  className: "teaserOverview__line"
})), subline && /*#__PURE__*/React$1.createElement("div", {
  className: "teaserOverview__excerpt"
}, /*#__PURE__*/React$1.createElement(Typography$1, {
  variant: "copy"
}, subline)));

TeaserOverview.propTypes = {
  headline: PropTypes$1.string,
  subline: PropTypes$1.string,
  link: PropTypes$1.shape()
};
TeaserOverview.defaultProps = {
  headline: null,
  subline: null,
  link: null
};

export default TeaserOverview;
